// extracted by mini-css-extract-plugin
export default {"container":"trim-video-thumbnail-sprite-module__container--WBO9z"};